import React from "react";
import useAdminListPartners from "../hooks/useAdminListPartners";
import AdminListPartners from "../components/AdminListPartners";

const { handleDelete = null } = useAdminListPartners;

export default function AdminListPartnersInterface(props) {
  const { onEdit, onSave, businessType, onEdit2 } = props;

  return (
    <React.Fragment>
      <AdminListPartners
        onSave={onSave}
        handleDelete={handleDelete}
        onEdit={onEdit}
        businessType={businessType}
        onEdit2={onEdit2}
      />
    </React.Fragment>
  );
}
